module.exports = __webpack_public_path__ + "img/17855_S.b7907b96.png";